import { ComponentType } from "@angular/cdk/portal";
import { Injectable, TemplateRef } from "@angular/core";
import { MatDialog, MatDialogRef, MatSnackBar, MatSnackBarRef, SimpleSnackBar } from "@angular/material";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

import { ConfirmComponent } from "../views/shared/confirm/confirm.component";
import { Logger } from "../model/logger.model";
import { LoggingService } from "./logging.service";
import { DialogResult } from "../support/dialog-result.model";
import { TypeSystem } from "../support/type-system.support";
import { AlertComponent } from "../views/shared/alert/alert.component";
import { ConfirmPointsComponent } from "../views/shared/confirm-points/confirm-points.component";

	/**
     * @description
     *  Servicio con utilidades para UI.
     */

@Injectable({ providedIn: "root" })
export class UIService {

	private logger: Logger = this.loggingService.getLogger("ui.service");

	constructor(
		private loggingService: LoggingService,
		private matDialog: MatDialog,
		private snackBar: MatSnackBar) {}

	public confirmationDialog(title: string, message: string, widthInPixels: number = 400, isPointsModule : boolean = false): Observable<boolean> {
		if(isPointsModule){
			return this.matDialog
			.open(ConfirmPointsComponent, {
				data: { mensaje: message, title: title },
				width: `${widthInPixels}px`
			})
			.afterClosed()
			.pipe(map(result => result === "ok"));
		}
		return this.matDialog
			.open(ConfirmComponent, {
				data: { mensaje: message, title: title },
				width: `${widthInPixels}px`
			})
			.afterClosed()
			.pipe(map(result => result === "ok"));
	}

	public errorDialog(title: string, message: string, widthInPixels: number = 400): Observable<boolean> {
		return this.matDialog
			.open(AlertComponent, {
				data: { title: title, mensaje: message },
				width: `${widthInPixels}px`
			})
			.afterClosed()
			.pipe(map(result => result === "ok"));
	}

	public errorNotification(message: string): MatSnackBarRef<SimpleSnackBar> {
		return this.snackBar.open(message, "Ok", {
			duration: 7.5 * 1000,
			horizontalPosition: "center",
			panelClass: ["toast-notification", "error"],
			verticalPosition: "bottom"
		});
	}

	public infoNotification(message: string): MatSnackBarRef<SimpleSnackBar> {
		return this.snackBar.open(message, "Ok", {
			duration: 4.0 * 1000,
			horizontalPosition: "center",
			verticalPosition: "bottom"
		});
	}

	public openDialog<T, D = any, R = typeof TypeSystem.EmptyObject>(component: ComponentType<T> | TemplateRef<T>)
			: MatDialogRef<T, DialogResult<R>> {
		return this.matDialog
			.open<T, D, DialogResult<R>>(component, {
				autoFocus: true,
				disableClose: true,
				hasBackdrop: true,
				restoreFocus: true,
				height: "auto",
				panelClass: "kt-mat-dialog-container__wrapper",
				width: "900px"
			});
	}

	public warningNotification(message: string): MatSnackBarRef<SimpleSnackBar> {
		return this.snackBar.open(message, "Ok", {
			duration: 7.5 * 1000,
			horizontalPosition: "center",
			panelClass: ["toast-notification", "warning"],
			verticalPosition: "bottom"
		});
	}
}
